import {
    STUDIO_ITEM_RESPONSE,
    STUDIO_ITEM_SAVE_RESPONSE,
    STUDIO_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { normalise } from "../../models/entities/map"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case STUDIO_ITEM_SAVE_RESPONSE:
        case STUDIO_ITEM_RESPONSE:
            return {
                ...state,
                [data.id]: {
                    ...normalise(data),
                    lastUpdatedAt: receivedAt
                }
            }
        case STUDIO_LIST_RESPONSE:
            return {
                ...state,
                ...extractEntitiesFromData(data, state)
            }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
